import axios from 'axios';

// Every write route answers with the whole updated user document, so the
// dashboard can replace its copy wholesale and the preview follows.
const auth = () => ({ headers: { 'auth-token': localStorage.getItem('auth-token') } });
const data = res => res.data;

const api = {
  me: () => axios.get('/users/admin', auth()).then(data),
  addLink: (username, link) => axios.patch(`/users/${username}`, link, auth()).then(data),
  editLink: (username, link) => axios.patch(`/users/${username}/editlink`, link, auth()).then(data),
  deleteLink: (username, id) => axios.patch(`/users/${username}/deletelink`, { _id: id }, auth()).then(data),
  reorder: (username, order) => axios.patch(`/users/${username}/links/reorder`, { order }, auth()).then(data),
  design: (username, fields) => axios.patch(`/users/${username}/design`, fields, auth()).then(data),
  name: (username, name) => axios.patch(`/users/${username}/name`, { name }, auth()).then(data),
  bio: (username, bio) => axios.patch(`/users/${username}/bio`, { bio }, auth()).then(data),
  avatar: (username, form) => axios.patch(`/users/${username}/avatar`, form, auth()).then(data),
  defaultAvatar: (username) => axios.patch(`/users/${username}/defaultAvatar`, {}, auth()).then(data),
  background: (username, form) => axios.patch(`/users/${username}/background`, form, auth()).then(data),
  analytics: (username) => axios.get(`/users/${username}/analytics`, auth()).then(data)
};

// The error code the server put in a failed response, if any
export const errorCode = err => err && err.response && err.response.data && err.response.data.code;

export const logout = () => {
  localStorage.removeItem('auth-token');
  window.location = '/';
};

export default api;
